import React, { Component } from 'react';

class Message extends Component {
	render() {
		return (
			<p>There are currently no resources matching your criteria</p>
		);
	}
}

export default Message;
